import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";
import {
  LectureCommentDetailDto,
  UpdateCommentStatusRequestDto,
} from "../../interfaces/lecture";
import { Paginated } from "../../models/common/paginated.model";

export const lectureCommentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLectureComments: builder.query<
      Paginated<LectureCommentDetailDto>,
      PaginateQuery
    >({
      query: (data) => ({
        url: buildPaginationQueryString(data, `/api/lecture-comment`),
      }),
      providesTags: ["Paginated-Lecture-Comments"],
    }),
    updateCommentStatus: builder.mutation<
      void,
      { id: string; data: UpdateCommentStatusRequestDto }
    >({
      query: ({ id, data }) => ({
        url: `/api/lecture-comment/${id}/status`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Paginated-Lecture-Comments"],
    }),
    deleteLectureComment: builder.mutation<void, string>({
      query: (id) => ({
        url: `/api/lecture-comment/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-Lecture-Comments"],
    }),
  }),
});

export const {
  useGetLectureCommentsQuery,
  useUpdateCommentStatusMutation,
  useDeleteLectureCommentMutation,
} = lectureCommentApi;
